import { render, staticRenderFns } from "./travel.vue?vue&type=template&id=359ee914"
import script from "./travel.vue?vue&type=script&lang=js"
export * from "./travel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports